import React from 'react';
import { useShowContext } from 'framework/show';
import { Typography } from '@mui/material';

const BenchAssignField = () => {
  const { data } = useShowContext();

  const { benchMinAssing, benchMaxAssing } = data.getData();
  return (
    <Typography variant="body2">
      {benchMinAssing}% - {benchMaxAssing}%
    </Typography>
  );
};

export default BenchAssignField;
